import dropdown from './components/dropdown/dropdown.component';
import modal from './components/modal/modal.component';

import fileSelectionChange from './directives/fileSelectionChange';

import MEDIA_STATUSES from './constants/media.statuses';
import TRACKING_EVENTS from './constants/trackingEvents';

import AppUtils from './services/appUtils';
import CampaignsService from './services/campaigns';
import CCASession from './services/ccaSession';
import CommunityService from './services/community';
import ContentCreatorAppAPI from './services/contentCreatorAppAPI';
import ErrorHandler from './services/errorHandler';
import FileTypes from './services/fileTypes';
import FileUtils from './services/fileUtils';
import LocationUtils from './services/locationUtils';
import Previewer from './services/previewer';
import ProfileService from './services/profile';
import Tracking from './services/tracking';
import UploadQueue from './services/uploadQueue';
import WaitForExternalLibrary from './services/waitForExternalLibrary';

import trackingEvents from './eventSubscribers/trackingEvents';

/**
 * @ngdoc overview
 * @name common
 * @description
 * This is the application common module.
 */
const commonModule = angular.module('common', [])
.service('appUtils', AppUtils)
.service('campaignsService', CampaignsService)
.service('ccaSession', CCASession)
.service('communityService', CommunityService)
.service('contentCreatorAppAPI', ContentCreatorAppAPI)
.service('errorHandler', ErrorHandler)
.service('fileTypes', FileTypes)
.service('fileUtils', FileUtils)
.factory('locationUtils', LocationUtils)
.service('previewer', Previewer)
.service('profileService', ProfileService)
.service('tracking', Tracking)
.service('uploadQueue', UploadQueue)
.service('waitForExternalLibrary', WaitForExternalLibrary)
.component('dropdown', dropdown)
.component('modal', modal)
.directive('fileSelectionChange', fileSelectionChange)
.constant('MEDIA_STATUSES', MEDIA_STATUSES)
.constant('TRACKING_EVENTS', TRACKING_EVENTS)
.run(trackingEvents);

export default commonModule.name;



// WEBPACK FOOTER //
// ./src/frontend/modules/common/index.js